import { ActivatedRoute, NavigationExtras } from '@angular/router';

export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;
}

export const buildEntityIdNavExtras = (entityId: string | number, route: ActivatedRoute): NavigationExtras => {
    return {
        relativeTo: route,
        queryParams: { entityId },
        queryParamsHandling: 'merge',
        preserveFragment: true,
    };
};

export const removeEntityIdParam = (route: ActivatedRoute): NavigationExtras => {
    return buildEntityIdNavExtras(null, route);
};
